
export default function formatCandidateJobFilterKey({
  jobId
}) {
  return `Job: ${jobId}`;
}
